import createIcon from '../../createIcon';

/**
 * @component @name Password
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMiAxNkgyMlYxOEgyVjE2Wk0zLjE1IDExLjk1TDQgMTAuNDdMNC44NSAxMS45NUw2LjE1IDExLjJMNS4zIDkuNzJIN1Y4LjIySDUuM0w2LjE1IDYuNzVMNC44NSA2TDQgNy40N0wzLjE1IDZMMS44NSA2Ljc1TDIuNyA4LjIySDFWOS43MkgyLjdMMS44NSAxMS4yTDMuMTUgMTEuOTVaTTkuODUgMTEuMkwxMS4xNSAxMS45NUwxMiAxMC40N0wxMi44NSAxMS45NUwxNC4xNSAxMS4yTDEzLjMgOS43MkgxNVY4LjIySDEzLjNMMTQuMTUgNi43NUwxMi44NSA2TDEyIDcuNDdMMTEuMTUgNkw5Ljg1IDYuNzVMMTAuNyA4LjIySDlWOS43MkgxMC43TDkuODUgMTEuMlpNMjMgOC4yMkgyMS4zTDIyLjE1IDYuNzVMMjAuODUgNkwyMCA3LjQ3TDE5LjE1IDZMMTcuODUgNi43NUwxOC43IDguMjJIMTdWOS43MkgxOC43TDE3Ljg1IDExLjJMMTkuMTUgMTEuOTVMMjAgMTAuNDdMMjAuODUgMTEuOTVMMjIuMTUgMTEuMkwyMS4zIDkuNzJIMjNWOC4yMloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Password = createIcon('Password', [
  [
    'path',
    {
      d: 'M2 16H22V18H2V16ZM3.15 11.95L4 10.47L4.85 11.95L6.15 11.2L5.3 9.72H7V8.22H5.3L6.15 6.75L4.85 6L4 7.47L3.15 6L1.85 6.75L2.7 8.22H1V9.72H2.7L1.85 11.2L3.15 11.95ZM9.85 11.2L11.15 11.95L12 10.47L12.85 11.95L14.15 11.2L13.3 9.72H15V8.22H13.3L14.15 6.75L12.85 6L12 7.47L11.15 6L9.85 6.75L10.7 8.22H9V9.72H10.7L9.85 11.2ZM23 8.22H21.3L22.15 6.75L20.85 6L20 7.47L19.15 6L17.85 6.75L18.7 8.22H17V9.72H18.7L17.85 11.2L19.15 11.95L20 10.47L20.85 11.95L22.15 11.2L21.3 9.72H23V8.22Z',
      key: 'zqy2j1',
    },
  ],
]);

export default Password;
